/* web/app/components/layout/main/main.scss */
:root {
  --bs-modal-header-padding: 1rem;
  --bs-modal-header-border-width: 1px;
  --bs-modal-header-border-color:#dee2e6;
  --bs-modal-inner-border-radius: calc(.3rem - 1px);
  --bs-modal-padding: 1rem;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-border-width: 1px;
  --bs-modal-footer-border-color: #dee2e6;
}
.main-layout-wrap {
  min-height: 100%;
}
.main-layout-wrap main-header {
  display: block;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 999;
}
.main-layout-wrap breadcrumbs[hidden] {
  display: none !important;
}
/*# sourceMappingURL=main.css.map */
